import React, { FC, useMemo } from 'react';
import { FormatterProps } from '../../../types';
import { ReactComponent as TagsExistSvg } from '../../../assets/tagsExist.svg';
import { ReactComponent as TagsMissingSvg } from '../../../assets/tagsMissing.svg';
import Spinner, { SPINNER_SIZES } from 'shared/components/andtComponents/Spinner';
import { useGovernanceTagsProcessing } from '../../../hooks/useGovernanceTagsProcessing';

import styles from './TagIconFormatter.module.scss';

const GovernanceTagIconFormatter: FC<FormatterProps> = ({ row }) => {
  const { isResourceProcessing } = useGovernanceTagsProcessing();

  const isProcessing = useMemo(() => {
    return row?.resourceId ? isResourceProcessing(row.resourceId) : false;
  }, [row?.resourceId, isResourceProcessing]);

  const hasGovernanceTags = useMemo(() => {
    return Array.isArray(row?.governanceTags) && row.governanceTags.length > 0;
  }, [row?.governanceTags]);

  if (isProcessing) {
    return (
      <div className={styles.spinnerContainer}>
        <Spinner size={SPINNER_SIZES.SMALL} position="static" style={{ transform: 'none' }} />
      </div>
    );
  }

  return hasGovernanceTags ? <TagsExistSvg /> : <TagsMissingSvg />;
};

export default GovernanceTagIconFormatter;
